const enum OrderServeType {
  DEFAULT = 'DEFAULT',
  DINE_IN = 'DINE_IN',
  TAKE_OUT = 'TAKE_OUT',
  DELIVERY = 'DELIVERY',
  PICK_UP = 'PICK_UP',
  SCHEDULE_TAKE_OUT = 'SCHEDULE_TAKE_OUT', // remove some day (進入menu 都用 preordertime 檢查)
}

export default OrderServeType;
